import React from "react";
import styled from "styled-components";

const SuccessMessage = ({ routetoPayment, paymentEmail }) => {
    return (
        <Message>
            <div className="success-message">
                <h4>Registration Successful!</h4>
                <p>Thank you for registering for the IUMRS-ICAM 2025 Conference.</p>
            </div>
            <div className="make-payment">
                <p>Would you like to proceed to payment window now?</p>
                <button onClick={(e) => routetoPayment(e, paymentEmail)}>
                    Make Payment
                </button>
            </div>
        </Message>
    );
};

const Message = styled.div`
    .success-message {
        text-align: center;
        margin-bottom: 1em;
        
        h4 {
            color: #4CAF50;
            font-size: 1.5em;
        }
    }
    
    .make-payment {
        text-align: center;
        
        p {
            margin-bottom: 0.8em;
        }

        button {
        margin-top: 1.3em;
        background-color: #CA9D3B;
        width: 8em;
        height: 3em;
        color: white;
        font-size: 1em;
        font-weight: 600;
        border: none;
        border-radius: 10px;
        cursor: pointer;
        transition: background-color 0.2s ease;
        
        &:hover {
            background-color: #b78d2e;
        }
    }
}   
`;

export default SuccessMessage;